import React, { useState } from 'react';
import { ArrowUpDownIcon, TrendingUpIcon, TrendingDownIcon } from 'lucide-react';
const PlayerStats = () => {
  const [activeTeam, setActiveTeam] = useState('home');
  const [sortField, setSortField] = useState('minutes');
  const [sortDirection, setSortDirection] = useState('desc');
  // Mock player stats data
  const playerStats = {
    home: {
      name: 'New York Knicks',
      color: 'red',
      players: [{
        id: 1,
        name: 'Jalen Brunson',
        position: 'PG',
        minutes: 38,
        points: 34,
        rebounds: 5,
        assists: 9,
        steals: 1,
        blocks: 0,
        turnovers: 3,
        fouls: 2,
        fgm: 12,
        fga: 22,
        tpm: 4,
        tpa: 9,
        ftm: 6,
        fta: 6,
        plusMinus: 8,
        efficiency: 38
      }, {
        id: 2,
        name: 'Donte DiVincenzo',
        position: 'SG',
        minutes: 35,
        points: 18,
        rebounds: 4,
        assists: 3,
        steals: 2,
        blocks: 0,
        turnovers: 1,
        fouls: 3,
        fgm: 6,
        fga: 13,
        tpm: 4,
        tpa: 9,
        ftm: 2,
        fta: 2,
        plusMinus: 6,
        efficiency: 24
      }, {
        id: 3,
        name: 'Josh Hart',
        position: 'SF',
        minutes: 40,
        points: 12,
        rebounds: 11,
        assists: 4,
        steals: 2,
        blocks: 1,
        turnovers: 2,
        fouls: 2,
        fgm: 5,
        fga: 10,
        tpm: 2,
        tpa: 5,
        ftm: 0,
        fta: 0,
        plusMinus: 9,
        efficiency: 26
      }, {
        id: 4,
        name: 'Julius Randle',
        position: 'PF',
        minutes: 34,
        points: 24,
        rebounds: 9,
        assists: 5,
        steals: 0,
        blocks: 1,
        turnovers: 4,
        fouls: 3,
        fgm: 9,
        fga: 19,
        tpm: 2,
        tpa: 6,
        ftm: 4,
        fta: 5,
        plusMinus: 3,
        efficiency: 28
      }, {
        id: 5,
        name: 'Mitchell Robinson',
        position: 'C',
        minutes: 28,
        points: 8,
        rebounds: 12,
        assists: 0,
        steals: 1,
        blocks: 3,
        turnovers: 1,
        fouls: 4,
        fgm: 4,
        fga: 5,
        tpm: 0,
        tpa: 0,
        ftm: 0,
        fta: 2,
        plusMinus: 5,
        efficiency: 22
      }, {
        id: 6,
        name: 'Immanuel Quickley',
        position: 'G',
        minutes: 18,
        points: 9,
        rebounds: 2,
        assists: 3,
        steals: 1,
        blocks: 0,
        turnovers: 1,
        fouls: 1,
        fgm: 3,
        fga: 8,
        tpm: 1,
        tpa: 4,
        ftm: 2,
        fta: 2,
        plusMinus: -2,
        efficiency: 12
      }, {
        id: 7,
        name: 'Isaiah Hartenstein',
        position: 'C',
        minutes: 20,
        points: 5,
        rebounds: 6,
        assists: 0,
        steals: 1,
        blocks: 0,
        turnovers: 1,
        fouls: 3,
        fgm: 2,
        fga: 4,
        tpm: 0,
        tpa: 0,
        ftm: 1,
        fta: 2,
        plusMinus: -1,
        efficiency: 10
      }, {
        id: 8,
        name: 'Miles McBride',
        position: 'G',
        minutes: 12,
        points: 2,
        rebounds: 1,
        assists: 0,
        steals: 0,
        blocks: 0,
        turnovers: 0,
        fouls: 0,
        fgm: 1,
        fga: 3,
        tpm: 0,
        tpa: 2,
        ftm: 0,
        fta: 0,
        plusMinus: -4,
        efficiency: 3
      }, {
        id: 9,
        name: 'Precious Achiuwa',
        position: 'F',
        minutes: 8,
        points: 0,
        rebounds: 3,
        assists: 0,
        steals: 0,
        blocks: 0,
        turnovers: 0,
        fouls: 2,
        fgm: 0,
        fga: 2,
        tpm: 0,
        tpa: 0,
        ftm: 0,
        fta: 0,
        plusMinus: -2,
        efficiency: 1
      }, {
        id: 10,
        name: 'Alec Burks',
        position: 'G',
        minutes: 7,
        points: 0,
        rebounds: 1,
        assists: 0,
        steals: 0,
        blocks: 0,
        turnovers: 0,
        fouls: 0,
        fgm: 0,
        fga: 2,
        tpm: 0,
        tpa: 1,
        ftm: 0,
        fta: 0,
        plusMinus: -2,
        efficiency: 1
      }]
    },
    away: {
      name: 'Los Angeles Lakers',
      color: 'blue',
      players: [{
        id: 1,
        name: 'LeBron James',
        position: 'SF',
        minutes: 39,
        points: 28,
        rebounds: 9,
        assists: 12,
        steals: 2,
        blocks: 1,
        turnovers: 5,
        fouls: 2,
        fgm: 11,
        fga: 21,
        tpm: 2,
        tpa: 7,
        ftm: 4,
        fta: 4,
        plusMinus: -2,
        efficiency: 42
      }, {
        id: 2,
        name: 'Anthony Davis',
        position: 'C',
        minutes: 38,
        points: 27,
        rebounds: 14,
        assists: 3,
        steals: 1,
        blocks: 2,
        turnovers: 3,
        fouls: 4,
        fgm: 10,
        fga: 18,
        tpm: 0,
        tpa: 1,
        ftm: 7,
        fta: 8,
        plusMinus: -1,
        efficiency: 40
      }, {
        id: 3,
        name: "D'Angelo Russell",
        position: 'PG',
        minutes: 36,
        points: 18,
        rebounds: 3,
        assists: 5,
        steals: 1,
        blocks: 0,
        turnovers: 2,
        fouls: 3,
        fgm: 7,
        fga: 16,
        tpm: 3,
        tpa: 8,
        ftm: 1,
        fta: 1,
        plusMinus: -5,
        efficiency: 21
      }, {
        id: 4,
        name: 'Austin Reaves',
        position: 'SG',
        minutes: 32,
        points: 15,
        rebounds: 4,
        assists: 2,
        steals: 1,
        blocks: 0,
        turnovers: 2,
        fouls: 2,
        fgm: 5,
        fga: 12,
        tpm: 2,
        tpa: 6,
        ftm: 3,
        fta: 4,
        plusMinus: 0,
        efficiency: 18
      }, {
        id: 5,
        name: 'Rui Hachimura',
        position: 'PF',
        minutes: 30,
        points: 10,
        rebounds: 5,
        assists: 0,
        steals: 0,
        blocks: 0,
        turnovers: 1,
        fouls: 3,
        fgm: 4,
        fga: 9,
        tpm: 1,
        tpa: 3,
        ftm: 1,
        fta: 2,
        plusMinus: -3,
        efficiency: 13
      }, {
        id: 6,
        name: 'Jarred Vanderbilt',
        position: 'F',
        minutes: 18,
        points: 4,
        rebounds: 6,
        assists: 0,
        steals: 2,
        blocks: 0,
        turnovers: 1,
        fouls: 4,
        fgm: 2,
        fga: 4,
        tpm: 0,
        tpa: 0,
        ftm: 0,
        fta: 0,
        plusMinus: 1,
        efficiency: 11
      }, {
        id: 7,
        name: 'Taurean Prince',
        position: 'F',
        minutes: 14,
        points: 3,
        rebounds: 2,
        assists: 0,
        steals: 0,
        blocks: 0,
        turnovers: 1,
        fouls: 1,
        fgm: 1,
        fga: 4,
        tpm: 1,
        tpa: 3,
        ftm: 0,
        fta: 0,
        plusMinus: -2,
        efficiency: 4
      }, {
        id: 8,
        name: 'Gabe Vincent',
        position: 'G',
        minutes: 12,
        points: 3,
        rebounds: 0,
        assists: 0,
        steals: 0,
        blocks: 0,
        turnovers: 0,
        fouls: 1,
        fgm: 1,
        fga: 3,
        tpm: 1,
        tpa: 3,
        ftm: 0,
        fta: 0,
        plusMinus: -4,
        efficiency: 3
      }, {
        id: 9,
        name: 'Jaxson Hayes',
        position: 'C',
        minutes: 10,
        points: 0,
        rebounds: 2,
        assists: 0,
        steals: 0,
        blocks: 0,
        turnovers: 0,
        fouls: 3,
        fgm: 0,
        fga: 1,
        tpm: 0,
        tpa: 0,
        ftm: 0,
        fta: 0,
        plusMinus: -3,
        efficiency: 2
      }, {
        id: 10,
        name: 'Christian Wood',
        position: 'F',
        minutes: 6,
        points: 0,
        rebounds: 1,
        assists: 0,
        steals: 0,
        blocks: 0,
        turnovers: 0,
        fouls: 2,
        fgm: 0,
        fga: 2,
        tpm: 0,
        tpa: 1,
        ftm: 0,
        fta: 0,
        plusMinus: -1,
        efficiency: 1
      }]
    }
  };
  // Sort players based on current sort field and direction
  const sortedPlayers = [...playerStats[activeTeam].players].sort((a, b) => {
    if (sortDirection === 'asc') {
      return a[sortField] - b[sortField];
    } else {
      return b[sortField] - a[sortField];
    }
  });
  // Handle column header click for sorting
  const handleSort = field => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('desc');
    }
  };
  // Calculate field goal percentage
  const calculateFGP = (fgm, fga) => {
    if (fga === 0) return '0.0';
    return (fgm / fga * 100).toFixed(1);
  };
  // Calculate three point percentage
  const calculateTPP = (tpm, tpa) => {
    if (tpa === 0) return '0.0';
    return (tpm / tpa * 100).toFixed(1);
  };
  // Calculate free throw percentage
  const calculateFTP = (ftm, fta) => {
    if (fta === 0) return '0.0';
    return (ftm / fta * 100).toFixed(1);
  };
  // Render sort indicator
  const renderSortIndicator = field => {
    if (sortField === field) {
      return sortDirection === 'asc' ? <TrendingUpIcon className="inline w-4 h-4 ml-1" data-id="element-691" data-mp="1crpl5nttzi7y" /> : <TrendingDownIcon className="inline w-4 h-4 ml-1" data-id="element-692" data-mp="yspwwha8d5cb" />;
    }
    return <ArrowUpDownIcon className="inline w-4 h-4 ml-1 opacity-30" data-id="element-693" data-mp="13sca4qq26ll4" />;
  };
  return <div className="bg-white rounded-lg shadow-md p-6" data-id="element-694" data-mp="13q9cbkinzo5u">
      <h2 className="text-xl font-bold mb-6" data-id="element-695" data-mp="ptmfdhqpoxzx">Player Statistics</h2>
      {/* Team Toggle */}
      <div className="flex mb-6 bg-gray-100 rounded-lg p-1 w-fit" data-id="element-696" data-mp="ttegj9ds01v9">
        <button onClick={() => setActiveTeam('home')} className={`px-4 py-2 text-sm font-medium rounded-md ${activeTeam === 'home' ? 'bg-white shadow text-red-600' : 'text-gray-600 hover:text-gray-800'}`} data-id="element-697" data-mp="2k6lxpimh86aw">
          New York Knicks
        </button>
        <button onClick={() => setActiveTeam('away')} className={`px-4 py-2 text-sm font-medium rounded-md ${activeTeam === 'away' ? 'bg-white shadow text-blue-600' : 'text-gray-600 hover:text-gray-800'}`} data-id="element-698" data-mp="cirbjjgfvnic">
          Los Angeles Lakers
        </button>
      </div>
      {/* Player Stats Table */}
      <div className="overflow-x-auto" data-id="element-699" data-mp="w8kvjbcwwyc0">
        <table className="min-w-full bg-white border border-gray-200" data-id="element-700" data-mp="w7i514ji4xwm">
          <thead data-id="element-701" data-mp="ra9nn666gxwf">
            <tr className="bg-gray-50 text-xs" data-id="element-702" data-mp="r8ou9jvlnl05">
              <th className="py-3 px-2 text-left font-medium text-gray-500 uppercase tracking-wider border-b sticky left-0 bg-gray-50 z-10" data-id="element-703" data-mp="rc2scfx8d81s">
                Player
              </th>
              <th className="py-3 px-2 text-center font-medium text-gray-500 uppercase tracking-wider border-b cursor-pointer" onClick={() => handleSort('minutes')} data-id="element-704" data-mp="108buw3gi8ms5">
                MIN {renderSortIndicator('minutes')}
              </th>
              <th className="py-3 px-2 text-center font-medium text-gray-500 uppercase tracking-wider border-b cursor-pointer" onClick={() => handleSort('points')} data-id="element-705" data-mp="1607rdi36lien">
                PTS {renderSortIndicator('points')}
              </th>
              <th className="py-3 px-2 text-center font-medium text-gray-500 uppercase tracking-wider border-b cursor-pointer" onClick={() => handleSort('rebounds')} data-id="element-706" data-mp="1jz7f8nivdt9r">
                REB {renderSortIndicator('rebounds')}
              </th>
              <th className="py-3 px-2 text-center font-medium text-gray-500 uppercase tracking-wider border-b cursor-pointer" onClick={() => handleSort('assists')} data-id="element-707" data-mp="1yn2b2cs6cdr2">
                AST {renderSortIndicator('assists')}
              </th>
              <th className="py-3 px-2 text-center font-medium text-gray-500 uppercase tracking-wider border-b cursor-pointer" onClick={() => handleSort('steals')} data-id="element-708" data-mp="2cmk3d24oi956">
                STL {renderSortIndicator('steals')}
              </th>
              <th className="py-3 px-2 text-center font-medium text-gray-500 uppercase tracking-wider border-b cursor-pointer" onClick={() => handleSort('blocks')} data-id="element-709" data-mp="3o4fttaavrhtc">
                BLK {renderSortIndicator('blocks')}
              </th>
              <th className="py-3 px-2 text-center font-medium text-gray-500 uppercase tracking-wider border-b" data-id="element-710" data-mp="js2c9yg3cis5">
                FG
              </th>
              <th className="py-3 px-2 text-center font-medium text-gray-500 uppercase tracking-wider border-b" data-id="element-711" data-mp="aww2kodp9gkc">
                3PT
              </th>
              <th className="py-3 px-2 text-center font-medium text-gray-500 uppercase tracking-wider border-b" data-id="element-712" data-mp="5x05za7c0ret">
                FT
              </th>
              <th className="py-3 px-2 text-center font-medium text-gray-500 uppercase tracking-wider border-b cursor-pointer" onClick={() => handleSort('turnovers')} data-id="element-713" data-mp="ymqd2zajqt1f">
                TO {renderSortIndicator('turnovers')}
              </th>
              <th className="py-3 px-2 text-center font-medium text-gray-500 uppercase tracking-wider border-b cursor-pointer" onClick={() => handleSort('fouls')} data-id="element-714" data-mp="982q74u4vef4">
                PF {renderSortIndicator('fouls')}
              </th>
              <th className="py-3 px-2 text-center font-medium text-gray-500 uppercase tracking-wider border-b cursor-pointer" onClick={() => handleSort('plusMinus')} data-id="element-715" data-mp="15y3ez3ui5uwf">
                +/- {renderSortIndicator('plusMinus')}
              </th>
              <th className="py-3 px-2 text-center font-medium text-gray-500 uppercase tracking-wider border-b cursor-pointer" onClick={() => handleSort('efficiency')} data-id="element-716" data-mp="1kv48ncw97zxj">
                EFF {renderSortIndicator('efficiency')}
              </th>
            </tr>
          </thead>
          <tbody data-id="element-717" data-mp="1uzkldxeft0x4">
            {sortedPlayers.map(player => <tr key={player.id} className={`hover:bg-${playerStats[activeTeam].color}-50`} data-id="element-718" data-mp="28q67rw33nszr">
                <td className={`py-3 px-2 border-b sticky left-0 bg-white z-10 hover:bg-${playerStats[activeTeam].color}-50`} data-id="element-719" data-mp="23s4fqlnp4jc5">
                  <div className="flex flex-col" data-id="element-720" data-mp="1bzx0npnu9ezv">
                    <span className="font-medium" data-id="element-721" data-mp="1c1hsh7irqju1">{player.name}</span>
                    <span className="text-xs text-gray-500" data-id="element-722" data-mp="1pzy9brachqpw">
                      {player.position}
                    </span>
                  </div>
                </td>
                <td className="py-3 px-2 text-center border-b" data-id="element-723" data-mp="31euz53ecsjyb">
                  {player.minutes}
                </td>
                <td className="py-3 px-2 text-center border-b font-medium" data-id="element-724" data-mp="2wga19amkqcd1">
                  {player.points}
                </td>
                <td className="py-3 px-2 text-center border-b" data-id="element-725" data-mp="34foexcm2bie4">
                  {player.rebounds}
                </td>
                <td className="py-3 px-2 text-center border-b" data-id="element-726" data-mp="38g8eemu3yy3f">
                  {player.assists}
                </td>
                <td className="py-3 px-2 text-center border-b" data-id="element-727" data-mp="3ig7k8bz58acl">
                  {player.steals}
                </td>
                <td className="py-3 px-2 text-center border-b" data-id="element-728" data-mp="2ksz4kxltpvii">
                  {player.blocks}
                </td>
                <td className="py-3 px-2 text-center border-b" data-id="element-729" data-mp="2pslht71njbrb">
                  {player.fgm}-{player.fga}
                  <div className="text-xs text-gray-500" data-id="element-730" data-mp="2upv3cblx739v">
                    {calculateFGP(player.fgm, player.fga)}%
                  </div>
                </td>
                <td className="py-3 px-2 text-center border-b" data-id="element-731" data-mp="2228zr3cozyn0">
                  {player.tpm}-{player.tpa}
                  <div className="text-xs text-gray-500" data-id="element-732" data-mp="270ivpg68r39o">
                    {calculateTPP(player.tpm, player.tpa)}%
                  </div>
                </td>
                <td className="py-3 px-2 text-center border-b" data-id="element-733" data-mp="1zfgomx53nuor">
                  {player.ftm}-{player.fta}
                  <div className="text-xs text-gray-500" data-id="element-734" data-mp="1ugm0dfod5dx9">
                    {calculateFTP(player.ftm, player.fta)}%
                  </div>
                </td>
                <td className="py-3 px-2 text-center border-b" data-id="element-735" data-mp="1kjhbv971p6da">
                  {player.turnovers}
                </td>
                <td className="py-3 px-2 text-center border-b" data-id="element-736" data-mp="1gkryhgm0botn">
                  {player.fouls}
                </td>
                <td className={`py-3 px-2 text-center border-b ${player.plusMinus > 0 ? 'text-green-600' : player.plusMinus < 0 ? 'text-red-600' : ''}`} data-id="element-737" data-mp="16svnj4yto480">
                  {player.plusMinus > 0 ? `+${player.plusMinus}` : player.plusMinus}
                </td>
                <td className="py-3 px-2 text-center border-b font-medium" data-id="element-738" data-mp="ssuntsuan2u4">
                  {player.efficiency}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
      {/* Team Totals */}
      <div className="mt-6" data-id="element-739" data-mp="2lo4025i51scu">
        <h3 className="text-lg font-semibold mb-3" data-id="element-740" data-mp="26rmpvhloqjrv">Team Totals</h3>
        <div className="overflow-x-auto" data-id="element-741" data-mp="26rczvu0n4cm6">
          <table className="min-w-full bg-white border border-gray-200" data-id="element-742" data-mp="2bqfuslmwp2gf">
            <thead data-id="element-743" data-mp="2bsiszsy7q1w8">
              <tr className="bg-gray-50 text-xs" data-id="element-744" data-mp="1xzkrrpz39fkr">
                <th className="py-3 px-2 text-left font-medium text-gray-500 uppercase tracking-wider border-b" data-id="element-745" data-mp="1xxq96ibahzju">
                  Team
                </th>
                <th className="py-3 px-2 text-center font-medium text-gray-500 uppercase tracking-wider border-b" data-id="element-746" data-mp="1o1n4p5sytotq">
                  PTS
                </th>
                <th className="py-3 px-2 text-center font-medium text-gray-500 uppercase tracking-wider border-b" data-id="element-747" data-mp="1sy3u03bwi98e">
                  REB
                </th>
                <th className="py-3 px-2 text-center font-medium text-gray-500 uppercase tracking-wider border-b" data-id="element-748" data-mp="1j0z3xsexptmb">
                  AST
                </th>
                <th className="py-3 px-2 text-center font-medium text-gray-500 uppercase tracking-wider border-b" data-id="element-749" data-mp="ven4l97lqioz">
                  STL
                </th>
                <th className="py-3 px-2 text-center font-medium text-gray-500 uppercase tracking-wider border-b" data-id="element-750" data-mp="19fzkjkmrikav">
                  BLK
                </th>
                <th className="py-3 px-2 text-center font-medium text-gray-500 uppercase tracking-wider border-b" data-id="element-751" data-mp="1jcc9y6b9ybzt">
                  FG
                </th>
                <th className="py-3 px-2 text-center font-medium text-gray-500 uppercase tracking-wider border-b" data-id="element-752" data-mp="1ed980uqlclw2">
                  3PT
                </th>
                <th className="py-3 px-2 text-center font-medium text-gray-500 uppercase tracking-wider border-b" data-id="element-753" data-mp="1o32i1rb34sy7">
                  FT
                </th>
                <th className="py-3 px-2 text-center font-medium text-gray-500 uppercase tracking-wider border-b" data-id="element-754" data-mp="220r0ytlldq0m">
                  TO
                </th>
                <th className="py-3 px-2 text-center font-medium text-gray-500 uppercase tracking-wider border-b" data-id="element-755" data-mp="29lfl6mk81dbg">
                  PF
                </th>
              </tr>
            </thead>
            <tbody data-id="element-756" data-mp="2jjvemw6q0yo4">
              <tr className={`bg-${playerStats[activeTeam].color}-50`} data-id="element-757" data-mp="2jkenlnee8cq0">
                <td className="py-3 px-2 border-b font-medium" data-id="element-758" data-mp="2emv7ehy4xpvf">
                  {playerStats[activeTeam].name}
                </td>
                <td className="py-3 px-2 text-center border-b font-medium" data-id="element-759" data-mp="1qwiu0rk4f0xg">
                  {playerStats[activeTeam].players.reduce((sum, player) => sum + player.points, 0)}
                </td>
                <td className="py-3 px-2 text-center border-b" data-id="element-760" data-mp="1vv2bofrolqk0">
                  {playerStats[activeTeam].players.reduce((sum, player) => sum + player.rebounds, 0)}
                </td>
                <td className="py-3 px-2 text-center border-b" data-id="element-761" data-mp="134kcvqxzqbce">
                  {playerStats[activeTeam].players.reduce((sum, player) => sum + player.assists, 0)}
                </td>
                <td className="py-3 px-2 text-center border-b" data-id="element-762" data-mp="34wlwnf6dkpof">
                  {playerStats[activeTeam].players.reduce((sum, player) => sum + player.steals, 0)}
                </td>
                <td className="py-3 px-2 text-center border-b" data-id="element-763" data-mp="1d10qt90fzlx">
                  {playerStats[activeTeam].players.reduce((sum, player) => sum + player.blocks, 0)}
                </td>
                <td className="py-3 px-2 text-center border-b" data-id="element-764" data-mp="3skvl6ouz3rj9">
                  {playerStats[activeTeam].players.reduce((sum, player) => sum + player.fgm, 0)}
                  -
                  {playerStats[activeTeam].players.reduce((sum, player) => sum + player.fga, 0)}
                  <div className="text-xs text-gray-500" data-id="element-765" data-mp="io68zzrffsg9">
                    {calculateFGP(playerStats[activeTeam].players.reduce((sum, player) => sum + player.fgm, 0), playerStats[activeTeam].players.reduce((sum, player) => sum + player.fga, 0))}
                    %
                  </div>
                </td>
                <td className="py-3 px-2 text-center border-b" data-id="element-766" data-mp="3r5158wdpyeld">
                  {playerStats[activeTeam].players.reduce((sum, player) => sum + player.tpm, 0)}
                  -
                  {playerStats[activeTeam].players.reduce((sum, player) => sum + player.tpa, 0)}
                  <div className="text-xs text-gray-500" data-id="element-767" data-mp="1suaoiii3diq5">
                    {calculateTPP(playerStats[activeTeam].players.reduce((sum, player) => sum + player.tpm, 0), playerStats[activeTeam].players.reduce((sum, player) => sum + player.tpa, 0))}
                    %
                  </div>
                </td>
                <td className="py-3 px-2 text-center border-b" data-id="element-768" data-mp="1dzcull7aol6y">
                  {playerStats[activeTeam].players.reduce((sum, player) => sum + player.ftm, 0)}
                  -
                  {playerStats[activeTeam].players.reduce((sum, player) => sum + player.fta, 0)}
                  <div className="text-xs text-gray-500" data-id="element-769" data-mp="2zcpcp3m2gtqg">
                    {calculateFTP(playerStats[activeTeam].players.reduce((sum, player) => sum + player.ftm, 0), playerStats[activeTeam].players.reduce((sum, player) => sum + player.fta, 0))}
                    %
                  </div>
                </td>
                <td className="py-3 px-2 text-center border-b" data-id="element-770" data-mp="q2q05a6b955t">
                  {playerStats[activeTeam].players.reduce((sum, player) => sum + player.turnovers, 0)}
                </td>
                <td className="py-3 px-2 text-center border-b" data-id="element-771" data-mp="zst23zvettga">
                  {playerStats[activeTeam].players.reduce((sum, player) => sum + player.fouls, 0)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>;
};
export default PlayerStats;